import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import { formatCurrency } from 'client/utils/formatter';
import { colors, H1, P14, P18 } from 'client/v3/typography';
import ModelSpecs from 'client/v3/components/ModelSpecs';
import ModelFeatures from 'client/v3/components/ModelFeatures';
import modelCodes from 'client/constants/modelCode';
import Link from '@ff/ui/Link';
import Icon from '@ff/ui/Icon';
import url from 'client/utils/url';
import useConfig from 'client/hooks/useConfig';
import ChangeModel from './ChangeModel';

export type OverviewProps = {
  modelCode: string;
  model: string;
  edition: string;
  name: string;
  specs: {
    title: string;
    description: string;
  }[];
  features: string[];
  price: number;
  order?: {
    modelCode: string;
    isOnWaitlist: boolean;
    ff91AllianceEligibility: boolean;
  }
}

export default function Overview(props: OverviewProps) {
  const {
    modelCode,
    model,
    specs,
    features,
    price,
    order,
  } = props;

  const formattedPrice = formatCurrency(price);
  const { APPONLY } = useConfig();
    order?.modelCode === modelCodes.FF91FuturistAlliance.fullModelCode && !order?.isOnWaitlist;

  return (
    <Container>
      <H1 fontSize='30px'>{model}</H1>
      { order && <ChangeModel /> }
      <SpecsContainer >
          <ModelSpecs
            specs={specs}
           />
      </SpecsContainer>
      <FeaturesContainer>
        <ModelFeatures
          features={features}
          align='left'
         />
      </FeaturesContainer>
      <PriceContainer>
        <P18>Base Price</P18>
        <P18>{formattedPrice}</P18>
      </PriceContainer>
      { APPONLY !== '1' && (
        <DetailLink href={url.getPageProduct(modelCode)} target='_blank'>
          <P14>Feature Details</P14>
          <Icon name='ff-icon-keyboard_arrow_right' fontSize='16px' />
        </DetailLink>
      ) }
    </Container>
  );
}

const Container = styled(Box)(({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  fontWeight: 400,
  textAlign: 'center',
  alignItems: 'center',
}));

const SpecsContainer = styled(Box)({
  paddingTop: '32px',
  paddingBottom: '32px',
  alignSelf: 'stretch',
});

const FeaturesContainer = styled(Box)({
  flex: 1,
  alignSelf: 'flex-start'
});

const PriceContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignSelf: 'stretch',
  paddingTop: '20px',
  paddingBottom: '20px',
  borderTop: colors.border7,
  borderBottom: colors.border8,
  marginTop: '38px',
});

const DetailLink = styled(Link)({
  display: 'flex',
  alignItems: 'center',
  marginTop: '38px',
});